// Blueberry Variety Stage

export type ClassName = 'flower' | 'blueberry';
export type SubClass = 'open' | 'closed' | 'petalfall' | 'not-clear';

export type Stage = {
  id: string;
  name: string;
  className: ClassName;
  colorSets?: (ColorLabel | ImageQualityIndicator)[][];
  subClasses?: SubClass[];
  displayColor?: ColorLabel;
  order: number;
};

export const COLOR_LABELS = [
  'gray',
  'green',
  'yellow',
  'pink',
  'red',
  'purple',
  'blue',
] as const;

export type ColorLabel = (typeof COLOR_LABELS)[number];

export type ImageQualityIndicator =
  | 'not-clear'
  | 'too-dark'
  | 'overexposed'
  | 'blurry';
